/**
 * Created by swandelow on 8/24/16.
 */

angular.module('CarsSaraBo').controller('SpecialOfferController', [
    '$scope', '$routeParams', '$location', '$rootScope', '$q', '$translate',
    'SpecialOfferService', 'FleetService', 'PointOfSaleService', 'CompanyService', 'ItemSelectorService', 'DateService', 
    'SpecialOfferUrlsService', 'GAService', 'NotificationService', 'SitesService', 'GeoService',
function (
    $scope, $routeParams, $location, $rootScope, $q, $translate,
    specialOfferService, fleetService, pointOfSaleService, companyService, itemSelectorService, dateService, 
    specialOfferUrlsService, gaService, notificationService, sitesService, geoService) {
    
    var offerType = 'discount';

    $scope.initialize = function () {
        $scope.specialOffer = {};
        $scope.companyOid = $routeParams.companyOid;
        $scope.carsSelector = {};
        $scope.pointsOfSaleSelector = {};
        $scope.sitesSelector = {};
        $scope.validationErrors = [];
        $scope.gaErrorsReport = [];
        $scope.setIgnoreGlobalHttpErrorHandling(true);
        $scope.defaultMinBookedDays = 1;
        $scope.defaultMaxBookedDays = 30;
        $scope.isCollapsed = true;
        $scope.view = {hasBookingWindow: false, hasBookingLength: false};
        $scope.editableSpecialOffer = $scope.loggedUserAllowed('PERM_SPECIAL_OFFER_CREATE');
        $scope.channels = [
            {value:'WEBSITE', checked:false},
            {value:'APPMOBILE', checked: false}
        ];
        companyService.get({oid: $routeParams.companyOid}, function (response) {
            $scope.isInternational= response.tradingType == "INTERNATIONAL";
            componentAction();
        });
    };

    function componentAction(){
        if ($routeParams.clone) {
            specialOfferService.fetch($scope.companyOid, $routeParams.clone)
                .then(function (response) {
                    $scope.specialOffer = response;
                    delete $scope.specialOffer.oid;
                    delete $scope.specialOffer.version;
                    $scope.specialOffer.validityPeriod = dateService.periodToDate(response.validityPeriod);
                    $scope.specialOffer.bookingWindow = dateService.periodToDate(response.bookingWindow);
                    $scope.specialOffer.minBookedDays = response.minBookedDays;
                    $scope.specialOffer.maxBookedDays = response.maxBookedDays;
                    $scope.specialOffer.approvalStatus = 'PENDING';
                    
                    $scope.view.hasBookingWindow = ($scope.specialOffer.bookingWindow != undefined);
                    $scope.view.hasBookingLength = (($scope.specialOffer.minBookedDays != undefined) && ($scope.specialOffer.maxBookedDays != undefined))
                    getPointsOfSaleAndFleet(function () {
                        channelsSelected($scope.specialOffer.channels);
                        if($scope.isInternational){
                            getSites();
                        }
                    });
                });
        } else {
            getPointsOfSaleAndFleet(function () {
                getSites();
            });
        }
    }

    function channelsSelected(channels) {
        for (var i in $scope.channels) {
            var ch = $scope.channels[i];
            ch.checked = channels.includes(ch.value);
        }
    }

    function goToSpecialOfferList() {
        $location.path(specialOfferUrlsService.homeOffersUrl($scope.companyOid)).search({});
    }

    function getPointsOfSaleAndFleet(callback) {
        function getFleet() {
            var fieldsCar = "oid,name,carModel";
            fleetService.get({companyOid: $scope.companyOid, fields: fieldsCar}, function (response) {
                $scope.fleet = response;
                var carsOid = _.map($scope.specialOffer.cars, 'oid');
                $scope.carsSelector = getCarsSelectorConfig($scope.fleet, carsOid);
            });
        }

        function getPointsOfSale() {
            pointOfSaleService.resource.query({companyOid: $scope.companyOid}, function (pointsOfSale) {
                var pointsOfSaleOid = _.map($scope.specialOffer.pointsOfSale, 'oid');
                $scope.pointsOfSaleSelector = pointOfSaleService.getPointsOfSaleSelectorConfig(pointsOfSale, pointsOfSaleOid);
            });
        }
        if(callback){callback.call();}
        getPointsOfSale();
        getFleet();
    }

    function getSites() { sitesService.query({} ,function (response) {
            $scope.sitesResponse = response;
            var sitesOid = _.map($scope.specialOffer.sites, 'oid');
            $scope.sitesSelector = getSitesSelectorConfig($scope.sitesResponse, sitesOid);
        });
    }

    function getCarsSelectorConfig(fleet, selectedCars) {
        var nameGenerator = function (car) {
            return car.carModel.brand + ' ' + car.carModel.model + ' - ' + car.name;
        };
        var cars = itemSelectorService.getItemsForSelector(fleet, selectedCars, nameGenerator);

        return itemSelectorService.newItemSelectorBuilder()
            .listOfItemsTitle("specialOffers.carsSelector.listOfItemsTitle")
            .listOfSelectedItemsTitle("specialOffers.carsSelector.listOfSelectedItemsTitle")
            .items(cars)
            .build();
    }

    function getSitesSelectorConfig(sitesResponse, selectedSites) {

        var nameGenerator = function (site) {
            return site.description != "OtherCountries"?  site.description : $translate.instant("specialOffers.site.OtherCountries");
        };

        var countryItems = itemSelectorService.getItemsForSelector(sitesResponse, selectedSites, nameGenerator);

        return itemSelectorService.newItemSelectorBuilder()
            .listOfItemsTitle("specialOffer.countrySelector.listOfItemsTitle")
            .listOfSelectedItemsTitle("specialOffers.countrySelector.listOfSelectedItemsTitle")
            .items(countryItems)
            .build();
    }

    $scope.save = function () {
        var deferred = $q.defer();
        clearErrorMessages();
        if (isValidForm() && $scope.specialOfferForm.$valid) {
            $scope.specialOffer.cars = _.map($scope.carsSelector.getSelectedItemsOid(), toObject);
            $scope.specialOffer.pointsOfSale = _.map($scope.pointsOfSaleSelector.getSelectedItemsOid(), toObject);
            $scope.specialOffer.channels = getSelectedChannels();
            $scope.specialOffer.isInternational = $scope.isInternational;
            $scope.specialOffer.specialOfferType = 'DISCOUNT';
            inspectSitesSelected();
            setDefaultBookingLength();
            specialOfferService.save($scope.companyOid, $scope.specialOffer)
                .then(function (response) {
                    deferred.resolve();
                    $scope.notifyGA("Guardar_promocion", "EXITO");
                    notificationService.displayToast('specialOffers.toast.createdOfferTitle', 'specialOffers.toast.createdOfferMessage', {"name": $scope.specialOffer.name});
                    goToSpecialOfferList();
                }, function (error) {
                    deferred.reject();
                    $scope.notifyGA("Guardar_promocion", "ERROR");
                    handleError(error);
                });
        } else {
            deferred.reject();
            $scope.notifyGA("Guardar_promocion", "ERROR");
            for (i in $scope.specialOfferForm.$error.required) {
                $scope.errorField[$scope.specialOfferForm.$error.required[i].$name] = "input-error";
            }
            notifyFormErrors($scope.specialOfferForm.$error);
        }
        return deferred.promise;
    };

    function getSelectedChannels() {
        var checkedChannels = $scope.channels.filter(channel => channel.checked === true);
        return checkedChannels.map(channel => channel.value);
    }


    function inspectSitesSelected() {
        if($scope.isInternational){
            $scope.specialOffer.sites = _.map($scope.sitesSelector.getSelectedItemsOid(), toObject);
        }
    }

    function toObject(oid) {
        return {
            'oid': oid
        }
    }

    function clearErrorMessages() {
        $scope.errorField = {};
        $scope.responseErrorMessage = null;
        $scope.responseErrorParams = null;
    }

    function setDefaultBookingLength() {
        if ($scope.specialOffer.minBookedDays && !$scope.specialOffer.maxBookedDays) {
            $scope.specialOffer.maxBookedDays = $scope.defaultMaxBookedDays;
        }
        if (!$scope.specialOffer.minBookedDays && $scope.specialOffer.maxBookedDays) {
            $scope.specialOffer.minBookedDays = $scope.defaultMinBookedDays;
        }
    }

    function handleError(responseError) {
        if (responseError.data && responseError.data.params) {
            trackError(responseError.data.message, responseError.data.params.name);
            $scope.responseErrorMessage = responseError.data.message;
            $scope.responseErrorParams = responseError.data.params;
        } else {
            $scope.validationErrors = responseError.data;
        }
        document.getElementById('error-message-container').scrollIntoView();
    }

    function trackError(message, param) {

        if (message.startsWith("specialOffers.validations.overlapping.")) {
            $scope.notifyGA("Error_duplicada", param);
        }
    };

    $scope.cancel = function () {
        $scope.notifyGA("Intencion_cancelar");
        $scope.showModal("CANCEL_ALERT_TITLE", "CANCEL_ALERT_DESCRIPTION", function () {
            $scope.notifyGA("Cancelar");
            goToSpecialOfferList();
        });
    };

    /** VALIDATIONS **/
    $scope.updateValidation = function (field) {
        if ($scope.errorField != undefined && $scope.errorField[field]) {
            $scope.errorField[field] = null;
        }
    };

    function registerGaError(field, errorType) {
        $scope.gaErrorsReport.push({"field": field, "errorType": errorType});
    }

    function isValidForm() {
        var isValid = true;
        $scope.validationErrors = [];
        $scope.gaErrorsReport = [];

        if (!_.some($scope.pointsOfSaleSelector.getSelectedItemsOid())) {
            isValid = false;
            $scope.errorField['pointsOfSale'] = "input-error";
        }

        if (!_.some($scope.carsSelector.getSelectedItemsOid())) {
            isValid = false;
            $scope.errorField['cars'] = "input-error";
        }

        if ($scope.isInternational && !_.some($scope.sitesSelector.getSelectedItemsOid())) {
            isValid = false;
            $scope.errorField['sites'] = "input-error";
        }

        if (!getSelectedChannels().length > 0) {
            isValid = false;
            $scope.errorField['channels'] = "input-error";
        }


        if ($scope.specialOffer.bookingWindow) {
            var period = $scope.specialOffer.bookingWindow;
            if (!dateService.isValidFromDate(period)) {
                isValid = false;
                $scope.errorField['bookingWindow'] = "input-error";
                $scope.validationErrors.push("specialOffers.errors.bookingWindow.invalidFromDate");
                registerGaError("bookingWindow.from", "invalid");
            }
            if (!dateService.isValidToDate(period)) {
                isValid = false;
                $scope.errorField['bookingWindow'] = "input-error";
                $scope.validationErrors.push("specialOffers.errors.bookingWindow.invalidToDate");
                registerGaError("bookingWindow.to", "invalid");
            }
            if($scope.specialOffer.validityPeriod) {
                var validity = $scope.specialOffer.validityPeriod;
                if(period.to > validity.to) {
                    isValid = false;
                    $scope.errorField['bookingWindow'] = "input-error";
                    $scope.validationErrors.push("specialOffers.errors.bookingWindow.validity");
                    registerGaError("bookingWindow", "invalid");
                }
            }
        }

        if ($scope.specialOffer.validityPeriod) {
            var period = $scope.specialOffer.validityPeriod;
            if (!dateService.isValidFromDate(period)) {
                isValid = false;
                $scope.errorField['validityPeriod'] = "input-error";
                $scope.validationErrors.push("specialOffers.errors.validityPeriod.invalidFromDate");
                registerGaError("validityPeriod.from", "invalid");
            }
            if (!dateService.isValidToDate(period)) {
                isValid = false;
                $scope.errorField['validityPeriod'] = "input-error";
                $scope.validationErrors.push("specialOffers.errors.validityPeriod.invalidToDate");
                registerGaError("validityPeriod.to", "invalid");
            }
        }

        if ($scope.specialOfferForm.$error.min) {
            var fieldNames = [];
            for (var ix in $scope.specialOfferForm.$error.min) {
                fieldNames.push($scope.specialOfferForm.$error.min[ix].$name);
            }
            if (_.includes(fieldNames, 'discountPercentage')) {
                isValid = false;
                $scope.errorField['discountPercentage'] = "input-error";
                $scope.validationErrors.push("specialOffers.errors.discountPercentage.invalid");
                registerGaError("discountPercentage", "invalid");
            }
            var invalidMinBookedDays = _.includes(fieldNames, 'minBookedDays');
            var invalidMaxBookedDays = _.includes(fieldNames, 'maxBookedDays');
            if (invalidMinBookedDays || invalidMaxBookedDays) {
                isValid = false;
                if (invalidMinBookedDays) {
                    $scope.errorField['minBookedDays'] = "input-error";
                    registerGaError("minBookedDays", "invalid");
                }
                if (invalidMaxBookedDays) {
                    $scope.errorField['maxBookedDays'] = "input-error";
                    registerGaError("maxBookedDays", "invalid");
                }
                $scope.validationErrors.push("specialOffers.errors.bookingLength.invalidValue");
            }
        }

        if ($scope.specialOfferForm.$error.max) {
            var fieldNames = [];
            for (var ix in $scope.specialOfferForm.$error.max) {
                fieldNames.push($scope.specialOfferForm.$error.max[ix].$name);
            }
            if (_.includes(fieldNames, 'discountPercentage')) {
                isValid = false;
                $scope.errorField['discountPercentage'] = "input-error";
                $scope.validationErrors.push("specialOffers.errors.discountPercentage.invalid");
                registerGaError("discountPercentage", "invalid");
            }
            var invalidMinBookedDays = _.includes(fieldNames, 'minBookedDays');
            var invalidMaxBookedDays = _.includes(fieldNames, 'maxBookedDays');
            if (invalidMinBookedDays || invalidMaxBookedDays) {
                isValid = false;
                if (invalidMinBookedDays) {
                    $scope.errorField['minBookedDays'] = "input-error";
                    registerGaError("minBookedDays", "invalid");
                }
                if (invalidMaxBookedDays) {
                    $scope.errorField['maxBookedDays'] = "input-error";
                    registerGaError("maxBookedDays", "invalid");
                }
                $scope.validationErrors.push("specialOffers.errors.bookingLength.invalidValue");
            }

        }

        if ($scope.specialOffer.minBookedDays && $scope.specialOffer.maxBookedDays) {
            if ($scope.specialOffer.minBookedDays > $scope.specialOffer.maxBookedDays) {
                isValid = false;
                $scope.errorField['maxBookedDays'] = "input-error";
                $scope.validationErrors.push("specialOffers.errors.bookingLength.invalidMaxValue");
                registerGaError("maxBookedDays", "lessThanMinBookedDays");
            }
        }

        if ($scope.specialOfferForm.$error.date) {
            var fieldNames = [];
            for (var i in $scope.specialOfferForm.$error.date) {
                fieldNames.push($scope.specialOfferForm.$error.date[i].$name);
            }
            var invalidValidityPeriod = _.includes(fieldNames, 'validityPeriod-to') || _.includes(fieldNames, 'validityPeriod-from');
            var invalidBookingWindow = _.includes(fieldNames, 'bookingWindow-to') || _.includes(fieldNames, 'bookingWindow-from');

            if (invalidValidityPeriod || invalidBookingWindow) {
                isValid = false;
                $scope.validationErrors.push('common.INVALID_DATE');

                if (invalidValidityPeriod) {
                    $scope.errorField['validityPeriod'] = "input-error";
                    registerGaError("validityPeriod", "invalid");
                }
                if (invalidBookingWindow) {
                    $scope.errorField['bookingWindow'] = "input-error";
                    registerGaError("bookingWindow", "invalid");
                }
            }
        }

        return isValid;
    }

    function notifyFormErrors(errors) {
        var carsNotSelected = $scope.errorField.cars != undefined;
        var posNotSelected = $scope.errorField.pointsOfSale != undefined;
        var sitesNotSelected = $scope.errorField.sites != undefined;
        var channelsNotSelected = $scope.errorField.channels != undefined;
        var hasRequiredError = errors != undefined && errors.required && errors.required.length > 0;
        var requiredFields = [carsNotSelected, posNotSelected, sitesNotSelected, channelsNotSelected];

        if(carsNotSelected) {
            registerGaError("cars", "required");
        }
        if(posNotSelected) {
            registerGaError("pointsOfSale", "required");
        }
        if(sitesNotSelected){
            registerGaError("sites", "required");
        }

        if(channelsNotSelected){
            registerGaError("channels", "required");
        }

        if(hasRequiredError) {
            for (i in errors.required) {
                var name = errors.required[i].$name;
                registerGaError(name, "required");
            }
        }

        if (hasRequiredError || checkRequiredFields(requiredFields)) {
            $scope.validationErrors.push("specialOffers.validations.completeRequiredFields");
        }
        if (errors && errors.invalidAmountFormat) {
            $scope.validationErrors.push("warning.invalidNumberFormat");
        }

        $scope.gaErrorsReport.forEach(function (gaError) {
            $scope.notifyGA("Errores_de_validacion", gaError)
        })

        document.getElementById('error-message-container').scrollIntoView();
    }

    function checkRequiredFields(requiredFields) {
        var result = requiredFields.reduce((req1, req2)=> req1 || req2);
        return result;
    }

    function promoGa() {
        var category = "Autos_promociones";
        var mapInfo = {
            "Seleccionar_promo": function (eventName) {
                gaService.notify(category, eventName, [offerType])
            },
            "Ver_mas_ayuda": function (eventName) {
                gaService.notify(category, eventName, [offerType]);
            },
            "Ver_menos_ayuda": function (eventName) {
                gaService.notify(category, eventName, [offerType]);
            },
            "Ayuda_util": function (eventName) {
                gaService.notify(category, eventName, [offerType]);
            },
            "Ayuda_no_util": function (eventName) {
                gaService.notify(category, eventName, [offerType]);
            },
            "Guardar_promocion": function (eventName, result) {
                gaService.notify(category, eventName, [offerType, result])
            },
            "Intencion_cancelar": function (eventName) {
                gaService.notify(category, eventName, [offerType])
            },
            "Cancelar": function (eventName) {
                gaService.notify(category, eventName, [offerType])
            },
            "Error_duplicada": function (eventName, name) {
                gaService.notify(category, eventName, [name])
            },
            "Errores_de_validacion": function (eventName, gaError) {
                gaService.notify(category, eventName, [offerType, gaError.field, gaError.errorType])
            }
        };
        return {
            send: function (eventName, params) {
                mapInfo[eventName].call(mapInfo, eventName, params);
            }
        }
    }

    var feedback = {
        es: "https://goo.gl/forms/3Ua85Gpq0bm4u7Gc2",
        pt: "https://goo.gl/forms/dB3Ro9GG1detKmF03",
        en: "https://goo.gl/forms/4VAaZ7iz6wjNGDzD2"
    };

    var gaInfo = promoGa();
    $scope.notifyGA = function (eventName, param) {
        gaInfo.send(eventName, param);
    };

    $scope.goToFeedbackForm = function () {
        window.open(feedback[$rootScope.lang.value]);
    };

    $scope.getLanguage = function(){
        return $rootScope.lang.name;
    }

    $scope.initialize();
    }]);



//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/special_offer_controller.js
// module id = 908
// module chunks = 3